import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../store';
import { OverlayContainer } from '@angular/cdk/overlay';
import { selectConsumerTheme } from '../../../store/profile/profile.state';

@Injectable()
export class ThemeService {

    private static switchTheme(classes: DOMTokenList, themeName: string): void {
        for (let i = classes.length - 1; i >= 0; i--) {
            const name = classes.item(i);
            if (name.indexOf('theme-') === 0) {
                classes.remove(name);
            }
        }
        classes.add(themeName);
    }

    constructor(private overlay: OverlayContainer, private store: Store<AppState>) {
        this.store.select(selectConsumerTheme).subscribe((name) => this.changeTheme(name));
    }

    changeTheme(name: string): void {
        ThemeService.switchTheme(document.documentElement.classList, name);
    }

}
